import { motion } from 'framer-motion';

export function HeroSection() {
    return (
        <section className="fixed inset-0 z-0 w-full h-[100dvh] flex flex-col justify-start md:justify-center box-border pointer-events-none">
            <motion.div className="flex flex-col flex-1 h-full md:h-auto md:grid md:grid-cols-2 gap-8 md:gap-10 max-w-7xl mx-auto w-full md:items-center pt-24 md:pt-0 md:px-8">

                {/* Content left */}
                <div className="w-full flex-shrink-0 flex flex-col justify-center items-center md:items-start order-1 relative z-20 mix-blend-difference mb-2 md:mb-0 px-6 mt-4 md:mt-0 pointer-events-auto">
                    <h1 className="text-[3.5rem] sm:text-6xl md:text-7xl lg:text-8xl font-serif tracking-tighter text-white mb-4 leading-[1.05] text-center md:text-left drop-shadow-[0_0_20px_rgba(255,255,255,0.1)] glow-text mix-blend-screen">
                        <span className="block text-[11px] sm:text-sm md:text-base lg:text-xl xl:text-2xl text-neutral-300 tracking-[0.2em] xl:tracking-[0.4em] font-sans font-light uppercase mb-4 opacity-80 glow-subtitle text-center md:text-left whitespace-nowrap">
                            Autonomous Software Ecosystems
                        </span>
                        <span className="block glow-title pb-2">Emilia Ivanova</span>
                        <span className="block text-brand glow-title-dim text-[2rem] sm:text-3xl md:text-5xl tracking-[0.2em] uppercase mt-2">Industries</span>
                    </h1>
                    <p className="text-neutral-400 font-light text-sm md:text-base lg:text-lg text-center md:text-left max-w-lg mt-4 leading-relaxed">
                        We build the architectures that decide how the world of tomorrow communicates, creates, and works. High-performance SaaS and autonomous workflows, empowering everyone from the ambitious founder to the global enterprise.
                    </p>
                    <div className="mt-10 flex gap-4 md:gap-6 justify-center md:justify-start flex-wrap">
                        <a href="https://replyra.me" target="_blank" rel="noreferrer" className="px-6 md:px-8 py-3 md:py-4 bg-brand text-black hover:bg-white transition-colors uppercase tracking-[0.2em] text-[10px] md:text-xs font-bold md:cursor-none text-center">
                            Explore SaaS
                        </a>
                        <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 md:px-8 py-3 md:py-4 bg-transparent border border-white/20 text-white hover:bg-white hover:text-black transition-colors uppercase tracking-[0.2em] text-[10px] md:text-xs font-bold md:cursor-none text-center">
                            Custom Integration
                        </a>
                    </div>
                </div>

                {/* Logo Animation Right */}
                <div className="w-full flex-1 md:flex-none min-h-0 flex justify-center items-center order-2 px-8 relative pb-10 md:pb-0">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, filter: "blur(20px)" }}
                        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                        transition={{ duration: 1.5, ease: "easeOut" }}
                        className="relative flex justify-center items-center w-48 h-48 sm:w-64 sm:h-64 md:w-[280px] md:h-[280px] mx-auto aspect-square rounded-full"
                    >
                        {/* Pulsing glow behind the logo */}
                        <motion.div
                            animate={{ scale: [1, 1.1, 1], opacity: [0.2, 0.4, 0.2] }}
                            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                            className="absolute inset-0 bg-brand/20 rounded-full blur-[40px]"
                        />
                        {/* The actual logo */}
                        <motion.img
                            animate={{ rotateY: [0, 10, -10, 0], y: [0, -10, 0] }}
                            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
                            src="/logo-dark.png"
                            alt="Emilia Ivanova Industries Global Logo"
                            className="w-full h-full object-cover rounded-full filter drop-shadow-[0_0_15px_rgba(255,255,255,0.1)] glow-image mix-blend-screen"
                        />
                    </motion.div>
                </div>

            </motion.div>
        </section>
    );
}
